export const canPushTimeRecordReportToZapier = webhookSubscriptions => {
    const hasReadTimeRecordZapHook = webhookSubscriptions.sort.find(id => {
        const subscription = webhookSubscriptions.items[id]
        if (!subscription) {
            return false
        }
        const { eventName, targetUrl } = subscription
        return (
            eventName == "read.TIMERECORD_REPORT" &&
            targetUrl.indexOf("https://hooks.zapier.com/") != -1
        )
    })
    return !!hasReadTimeRecordZapHook
}

export const webhookSubscriptionArrayToModuleState = raw => {
    const webhookSubscriptions = raw.reduce(
        (acc, i) => {
            const { id } = i
            return {
                items: { ...acc.items, [id]: i },
                sort: [...acc.sort, id],
            }
        },
        { items: {}, sort: [] },
    )
    return webhookSubscriptions
}



// WEBPACK FOOTER //
// ./src/util/webhook_subscriptions_utils.js